import { capitalize } from "lodash-es";
import React, { useEffect } from "react";

import { ISearchResult } from "types";

interface SearchResultsProps {
  results: ISearchResult[];
  term: string;
}

export const SearchResults: React.FC<SearchResultsProps> = ({
  term,
  results,
}) => {
  useEffect(() => {
    const titles = document.querySelectorAll(".basic-teaser__title");
    const descriptions = document.querySelectorAll(
      ".basic-teaser__description"
    );

    titles.forEach((title) => {
      title.innerHTML = title.innerHTML
        .replaceAll(term, `<span class='highlight-term'>${term}</span>`)
        .replaceAll(
          capitalize(term),
          `<span class='highlight-term'>${capitalize(term)}</span>`
        );
    });

    descriptions.forEach((description) => {
      description.innerHTML = description.innerHTML
        .replaceAll(term, `<span class='highlight-term'>${term}</span>`)
        .replaceAll(
          capitalize(term),
          `<span class='highlight-term'>${capitalize(term)}</span>`
        );
    });
  });

  return (
    <ul className="search-results">
      {results.map((result) => (
        <li key={result.document.id}>
          <div dangerouslySetInnerHTML={{ __html: result.document.teaser }} />
        </li>
      ))}
    </ul>
  );
};
